import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// import CollaboratorNetwork from "../../_components/CollaboratorNetworkProfile/CollaboratorNetwork";

// import { getCollaboratorNetwork } from "../../actions/collaboratorNetworkAction/getCollaboratorNetwork";
// import { getExpertCollabs } from "../../actions/collaboratorNetworkAction/getExpertCollabs";

//collab network profile
import { getCollaboratorNetworkProfile } from "../../actions/collabNetworkProfileAction/getCollaboratorNetworkProfile";
import { getExpertCollabsProfile } from "../../actions/collabNetworkProfileAction/getExpertCollabs";

import { getProfilesSuggest } from "../../actions/expertProfileSearchAction/collabProfileSearchAction";

// ***async loading***
import Loadable from "react-loadable";
import Loader from "../../_components/Loader/Loader"

const CollaboratorNetwork = Loadable({
  loader: () => import("../../_components/CollaboratorNetworkProfile/CollaboratorNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  )
});

class CollaboratorNetworkProfileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { keyword, globalKeyword, getCollaboratorNetworkProfile, token } = this.props;
    // if (keyword !== globalKeyword) {
    //   getCollaboratorNetworkProfile(globalKeyword, token);
      
      

      
    // }
    // this.searchCollabsNetwork("AJINA,SARA");
    // this.props.getCollaboratorNetworkProfile("AJINA,SARA", this.props.token);
    // AUTO SCROLL TO TOP WHEN PAGE LOADS
    window.scrollTo(0, 0);
  }

  searchCollabsNetwork = keyword => {
    this.props.getCollaboratorNetworkProfile(keyword, this.props.token);
  };

  getExpertCollabs = id => {
    const {  keyword,getExpertCollabsProfile, token } = this.props;
    getExpertCollabsProfile(id, token);
  };

  getProfiles = (keyword) => {
    
    if(keyword !== this.props.globalKeyword){
    this.props.getProfilesSuggest(keyword, this.props.token);
    this.props.history.push({
      pathname: `/result/collaborator-network/profile-search`,
      // search: "?q=all"
    });


    }
    
    
    
  };

  render() {
    const {
      nodes,
      error,
      isFetching,
      isInitalScreen,
      keyword,
      edges,
      isCollabsFetching,
      allCollabs,
      selectedId
    } = this.props;

    return (
      <div>
        <CollaboratorNetwork
          nodes={nodes}
          edges={edges}
          erorr={error}
          isFetching={isFetching}
          isInitalScreen={isInitalScreen}
          keyword={keyword}
          searchCollabsNetwork={this.searchCollabsNetwork}
          getProfiles ={this.getProfiles}
          getExpertCollabs={this.getExpertCollabs}
          searchCollabsNetwork={this.searchCollabsNetwork}
          isCollabsFetching={isCollabsFetching}
          allCollabs={allCollabs}
          selectedId={selectedId}
        />
      </div>
    );
  }
}

CollaboratorNetworkProfileContainer.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  nodes: PropTypes.array.isRequired,
  edges: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isInitalScreen: PropTypes.bool.isRequired,
  globalKeyword: PropTypes.string.isRequired,
  getExpertCollabs: PropTypes.func,
  isCollabsFetching: PropTypes.bool.isRequired,
  allCollabs: PropTypes.array.isRequired,
  selectedId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  isFetching: state.CollaboratorNetworkProfile.isFetching,
  error: state.CollaboratorNetworkProfile.error,
  isInitalScreen: state.CollaboratorNetworkProfile.isInitalScreen,
  keyword: state.CollaboratorNetworkProfile.keyword,
  nodes: state.CollaboratorNetworkProfile.nodes,
  edges: state.CollaboratorNetworkProfile.edges,
  globalKeyword: state.Global.keyword,
  isCollabsFetching: state.CollaboratorNetworkProfile.isCollabsFetching,
  allCollabs: state.CollaboratorNetworkProfile.allCollabs,
  selectedId: state.CollaboratorNetworkProfile.selectedId,
  token: state.Global.token
});

export default connect(
  mapStateToProps,
  {
    
    getCollaboratorNetworkProfile,
    getExpertCollabsProfile,

    getProfilesSuggest

  }
)(CollaboratorNetworkProfileContainer);
